export default __webpack_public_path__ + "static/media/accordian_bg.ef27885e.jpg";